import "./ui/styles.css";
import { mountApp } from "./ui/app.ts";
import { store } from "./store/state.ts";
import { describeError } from "./core/errors.ts";
import { parseClipPackRecvSecret, parseClipPackSendTarget, parseSendTarget, parseTransferSecret } from "./transfer/crypto.ts";
import {
  openClipPackReceiveDialog,
  openReceiveDialog,
  setPendingClipPackSendTarget,
  setPendingSendTarget,
} from "./ui/transferView.ts";

const root = document.getElementById("app");
if (!root) {
  throw new Error("#app が見つかりません");
}

mountApp(root);

// QR / URL のハッシュフラグメントを処理する（M4 リレー転送）。
//   #<code>:<key>:<iv>           … Unity が送ってきた .fmavatar を受信する
//   #send:<code>:<key>:<iv>      … Unity が受信待ち。次の書き出しをその箱へ投函する
//   #sendclip:<code>:<key>:<iv>  … Unity が表情クリップパックの受信待ち
//   #recvclip:<code>:<key>:<iv>  … Unity が送ってきた表情クリップパックを受信する
const hash = location.hash;
const sendTarget = parseSendTarget(hash);
const clipSendTarget = sendTarget ? null : parseClipPackSendTarget(hash);
const clipRecvSecret = sendTarget || clipSendTarget ? null : parseClipPackRecvSecret(hash);
const recvSecret = sendTarget || clipSendTarget || clipRecvSecret ? null : parseTransferSecret(hash);
if (sendTarget || clipSendTarget || clipRecvSecret || recvSecret) {
  // 鍵をアドレスバー・履歴に残さない
  history.replaceState(null, "", location.pathname + location.search);
}
if (sendTarget) {
  setPendingSendTarget(sendTarget);
  store.setBanner({
    kind: "info",
    title: "Unity が受信待ちです",
    detail: "「書き出し」タブの「Unity へ直接送信」を押すと、この端末で作った表情がそのまま Unity に届きます。",
    hint: null,
  });
}
if (clipSendTarget) {
  setPendingClipPackSendTarget(clipSendTarget);
  store.setBanner({
    kind: "info",
    title: "Unity が受信待ちです",
    detail: "クリップ一覧の「リレーで送信」を押すと、選んだ表情クリップがそのまま Unity に届きます。",
    hint: null,
  });
}

// 前回のアバターを復元する（失敗しても起動は継続）
void store
  .restore()
  .catch((e) => {
    const d = describeError(e);
    store.setBanner({ kind: "error", title: d.title, detail: d.detail, hint: d.hint });
  })
  .finally(() => {
    // 復元後に開く（受信が成功すると読み込み中アバターを置き換えるため）
    if (recvSecret) openReceiveDialog(`${recvSecret.code}:${recvSecret.keyB64}:${recvSecret.ivB64}`);
    if (clipRecvSecret) openClipPackReceiveDialog(`${clipRecvSecret.code}:${clipRecvSecret.keyB64}:${clipRecvSecret.ivB64}`);
  });
